import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((themes) => ({
    main: {
        height: '300%',
        overflow: 'auto',
    },
    searchForm: {
        marginTop: 0,
        top: 56,
        position: 'absolute',
        left: 0,
        right: 0,
        padding: '18px 24px 0 ',
        '@media (max-width: 1024px)': {
            position: 'fixed',
        },
    },
    searchIcon: {
        position: 'absolute',
        left: 10,
        top: 2,
        color: 'white',
    },

    input: {
        padding: '10px 0 10px 30px',
        background: 'transparent',
        border: 'none',
        borderBottom: '1px solid #4a6c72 ',
        color: 'white',
        fontSize: 14,
        position: 'relative',
    },
    filter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        // marginBottom: 10
    },
    chipOutline: {
        border: `1px solid ${themes.palette.grey['300']}`,
    },
    chipLabel: {
        padding: '0 8px',
        color: 'white',
        fontFamily: 'PoppinsRegular',
        fontSize: 12,
        fontWeight: 600,
    },
    chipIcon: {
        color: 'white',
    },
    stylistList: {
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    singleStylist: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '16px',
        paddingBottom: '12px',
        borderBottom: '1px solid #4A6C72',
    },
    profileImageBox: {
        width: '64px',
        height: '64px',
        position: 'relative',
        overflow: 'hidden',
    },
    profileImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '50%',
    },
    stylistLevel: {
        position: 'absolute',
        bottom: '2px',
        right: '2px',
        width: '20px',
        height: '20px',
        borderRadius: '50%',
    },
    detailBox: {
        flex: 1,
        textAlign: 'left',
        padding: '0 10px',
        color: themes.palette.primary.main,
    },
    stylistName: {
        fontFamily: 'PoppinsRegular',
        fontWeight: 600,
        fontSize: '16px',
    },
    stylistBio: {
        fontFamily: 'PoppinsRegular',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '16px',
    },
    selectBtn: {
        fontFamily: 'PoppinsRegular',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '20px',
        color: themes.palette.primary.main,
        border: `1px solid`,
        borderRadius: '42px',
        backgroundColor: 'transparent',
        padding: '8px 12px',
    },
}));
